import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AccountService } from 'src/app/services/account.service';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { SessionDataService } from 'src/app/services/session-data.service';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { VerificationComponent } from '../verification/verification.component';
import { environment } from 'src/environments/environment';
import { AppSettings } from 'src/app/enums/app-settings.enum';

@Component({
  selector: 'app-addon-grid',
  templateUrl: './addon-grid.component.html',
  styleUrls: ['./addon-grid.component.scss'],
})
export class AddonGridComponent implements OnInit {
  @Input('sku') sku: any;
  @Input('product') product: any;
  @Input('index') index: any;
  @Input('cat') cat: any;
  @Input('addonType') addonType: any;
  @Input('roaming') roaming: any;
  @Input() isParentalControl: boolean;

  @Input('promotionCheck') promotionCheck:any;
  @Input('titleLength') titleLength: any;
  @Input('promotionLength') promotionLength: any;
  ismobileScreen = false;
  categoryDetail: any;
  addon: any;
  currentAccount: any;
  isTravelInsuranceAddon: Boolean;
  travelInsuranceLabel: String;
  recommendedAddonsSkus: any[];
  currentLanguage: string;
  subCategory: any;
  oldFreedom: boolean;
  isControlLine: boolean;
  newAddonCard: boolean = false;
  constructor(
    private SKUDS: SkuDataService,
    private route: Router,
    private modalController: ModalController,
    private AS: AccountService,
    private SS: SubjectService,
    private SDS: SessionDataService,
    private GAS: GoogleAnalyticsService,
    private AAS: AdobeAnalyticsService,
    private UTS: UtilitiesService,
    private aRoute: ActivatedRoute,
  ) {
    this.currentLanguage = this.UTS.getLocaleLanguage();
    this.aRoute.queryParams.subscribe((q) => {
      this.subCategory = q && q?.subCategory || '';
      if (q && q.subCategory && q.subCategory === 'Njg=') {
        this.oldFreedom = true;
      }
      if (q && q.subCategory && q.subCategory === AppSettings.CONTROL_LINE) {
        this.isControlLine = true;
      }
        if (q && q?.newAddonCard) {
          this.newAddonCard = q?.newAddonCard;
        }
      });
    this.SS.sku.subscribe((main) => {
      if (main && main.name && main.value) {
        (this.addon = main.name), (this.categoryDetail = main.value);
      }
    });
    if (localStorage.getItem('currentAccount')) {
      const currentAccount = JSON.parse(
        localStorage.getItem('currentAccount')
      );
      if (currentAccount) {
        this.currentAccount = currentAccount;
      }
    }
    this.SS.recommendedAddonsSkus.subscribe((r) => {
      if (r && r.length > 0) {
        this.recommendedAddonsSkus = [];
        this.recommendedAddonsSkus = r;
        for (let i = 0; i < this.recommendedAddonsSkus.length; i++) {
            const skuId = this.recommendedAddonsSkus[i];
            if (skuId == this.sku?.skuId) {
              const recommend = {
                recommended: true,
              }
              this.sku = { ...this.sku, ...recommend };
            }
        }
      }
    });
  }

  ngOnInit() {
    const w = document.documentElement.clientWidth || window.innerWidth;
		if (w < 992) {
			this.ismobileScreen = true;
		  } else {
			this.ismobileScreen = false;
		  }
    this.removingKeyBenefits();
    this.checkTravelInsuranceAddon();
  }

  openDetailPage(sku: any, i: number) {
    if(this.isParentalControl){
        if(i==0){
          window.location.href = environment.BASE_URL + `/smartHomeConfiguration?productId=${sku.productId}&skuId=${sku.skuId}&locale=${
            this.UTS.getLocaleLanguage().toLocaleLowerCase()}`;
        } else{
          this.route.navigateByUrl(`/parentalControlAddons/detail?productId=${sku.productId}&skuId=${sku.skuId}&lang=${
            this.UTS.getLocaleLanguage().toLocaleLowerCase()}`);
        }
    } else{
      this.SKUDS.set(sku);
      this.SDS.setAddon(this.addon);
      this.SS.resetVerification.next(true)
      setTimeout(() => {
        let catID = '';
        if(localStorage.getItem('CAT')){
          catID = localStorage.getItem('CAT');
        }
        if (i == 0) {
          this.GAS.onSubscribeSuccessAddon(
            'Select_item',
            'Addons',
            sku?.productType,
            sku?.displayName,
            sku?.brand,
            catID,
            sku?.id ? sku?.id : sku?.skuId ? sku?.skuId : '',
            sku?.validity,
            "WEB",
            sku?.listPrice,
            "AED",
            "1"
          );
          this.AAS.addSubscribeNowCTAEvent("subscribe", "other", document.title + ":buy addons", this.sku.vasIsEligibleForAccountType + " - " + this.sku.displayName, "subscribe addon", this.sku.displayName, this.sku.listPrice,
                                    this.sku.type, "addons", this.sku.description);
          this.subscribe(sku);
        } else {
          this.GAS.onClickDetailsButton('addons_cta_click',sku?.displayName,'Details',sku?.skuId);
          this.AAS.addLinkCTAEvent('see details', "other", "configure", this.sku.vasIsEligibleForAccountType + " - " + this.sku.displayName, 'see details');
        //  this.AAS.addLinkCTAEvent('see details', "other", "configure", this.sku.vasIsEligibleForAccountType + " - " + this.sku.displayName, 'see details');
        if (this.roaming) {
          localStorage.setItem('isRoaming', 'true');
        }
        const navigationExtras: NavigationExtras = {
          state: {
           roaming:this.roaming
          }
        };
        this.route.navigateByUrl(`/addon/detail?skuId=${sku.skuId}&lang=${
          this.UTS.getLocaleLanguage().toLocaleLowerCase()}`,navigationExtras);
        }
      }, 500);
    }
    
  }

  private subscribe(sku: any) {
    this.productClick_Roaming();
    if(this.roaming)
    {
      localStorage.setItem('isRoaming','true');
    }
    const userInfo: any = this.AS.getUInfo();
      this.SS.skuDetails.next(sku);
       if(this.roaming)
       {
        this.openBottomSheet(VerificationComponent,{type:this.addonType, planName:this.sku?.displayName, roaming:true});
       }
       else{
        this.openBottomSheet(VerificationComponent,{type:this.addonType});
       }
     
  }
  productClick_Roaming()
  {
   if(this.roaming)
   {
  
    let product=[{
      name: this.sku?.displayName,
      id:  this.sku?.id ? this.sku.id : this.sku.skuId ? this.sku.skuId : '',
      price: +this.sku?.listPrice,
      brand:this.sku?.brand,
      category:'Roaming',
      user_env:this.UTS.getENV(),
      variant:'black',
      position:this.index+1
    }];

    let modal_data={
      event:'productClick',
      user_env: this.UTS.getENV(),
      ecommerce:{
        click:{
          actionField:{list:'Search Results'},
          products:product
        }
        
      }
    }
    this.GAS.productClick_RoamingType(modal_data);
   }

   
  }
  async openBottomSheet(component: any,data) {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      // mode: "ios",
      cssClass: 'verification-modal modal-fullscreen',
    });
    return await modal.present();
  }

  public productClick() {
    this.GAS.productClick(
    this.cat,
    this.product?.value,
    this.sku?.displayName,
    this.sku?.id ? this.sku.id : this.sku.skuId ? this.sku.skuId : '',
    this.sku?.listPrice,
    this.index+1,
    this.sku?.brand,
  );
   localStorage.setItem('ProductCategory',JSON.stringify({cat:this.cat,product:this.product?.value,position:this.index+1}));
  }
  removeDec(n){
    if(!n || (!Number(n))) return n
    return  Number(n)
  }

  removingKeyBenefits(){
    const data = this.sku && this.sku.keyBenefits && this.sku.keyBenefits.filter(x=>x.unit !== 'roamingCountryList') || [];
    if(this.sku && this.sku.keyBenefits){
      this.sku.keyBenefits = data;
    }
  }
  checkTravelInsuranceAddon(){
    // this.sku['rewardList'] = [
    //   {key:'travelInsurance', value: 'Travel insurance option'}
    // ]
    if(this.sku && this.sku.rewardList && this.sku.rewardList.length > 0){
      this.sku.rewardList.forEach(item => {
        if(item.key && item.key == "travelInsurance"){
          this.isTravelInsuranceAddon = true;
          this.travelInsuranceLabel = item.value ? item.value : '';
        }
      });
    }
  }

  restrictString(str){
   return this.UTS.restrictString(str)
  }
  formatAmount(amount){
    return this.UTS.formatAmount(amount)
  }
  
  
  setStatusLabelColor(tile: any) {
    var style;
    if (tile && tile?.backgroundColor && tile?.backgroundColor.includes(',')) {
      style = {
        'background-image': 'linear-gradient(to left,' + tile?.backgroundColor + ')',
        color: tile?.textColor
      }
    }
    else {
      style = {
        'background-color': tile?.backgroundColor,
        color: tile?.textColor
      }
    }
    return style;
  }
  setPremiumLabelColor(tile) {
    if (tile && tile?.value && tile.value.toLowerCase() == 'bronze')
      return 'eand-bg-gradient-bronze';
    else if (tile && tile?.value && tile.value.toLowerCase() == 'gold' || tile && tile?.value && tile.value.toLowerCase() == 'gold plus')
      return 'eand-bg-gradient-gold';
    else if (tile && tile?.value && tile.value.toLowerCase() == 'standard' || tile && tile?.value && tile.value.toLowerCase() == 'silver plus' || tile && tile?.value && tile.value.toLowerCase() == 'silver')
      return 'eand-bg-gradient-silver';
    else if (tile && tile?.value && tile.value.toLowerCase() == 'platinum')
      return 'eand-bg-gradient-premuim';
  }
  
  keyBenefitsValue(kb){
    return (kb && !isNaN(kb?.value)) ? this.removeDec(kb?.value) + ' ' +  kb?.unit : kb?.value + ' ' +  kb?.unit
  }
}
